import { ApolloClient, gql } from 'apollo-boost';

export interface DonorAccount {
  dbId: number;
  name: string;
}

export interface QueueInvestment {
  dbId: number;
  cashAmount: number | null;
  programNameByDonor: string | null;
  siteId: number | null;
  status: string | null;
  organization: string | null;
  paymentDate: string | null;
  paymentType: string | null;
}

export interface QueuePortfolio {
  dbId: number;
  name: string;
  year: number | null;
  investments: QueueInvestment[];
}

export interface TargetPortfolio {
  dbId: number;
  name: string;
  year: number | null;
}

export interface DonorsResponse {
  partnerQueueAccounts: DonorAccount[];
}

export interface PartnerQueueResponse {
  partnerQueuePortfolios: QueuePortfolio[];
}

export interface AdminAccountPortfoliosResponse {
  adminAccountPortfolios: TargetPortfolio[];
}

export interface MoveToPortfolioResponse {
  updateInvestment: { success: boolean; id: number | null; error: string | null };
}

const partnerQueueAccountsQuery = gql`
  {
    partnerQueueAccounts {
      dbId
      name
    }
  }
`;

const partnerQueueQuery = gql`
  query PartnerQueuePortfolios($accountId: Int!) {
    partnerQueuePortfolios(accountId: $accountId) {
      dbId
      name
      year
      investments {
        dbId
        cashAmount
        programNameByDonor
        siteId
        status
        organization
        paymentDate
        paymentType
      }
    }
  }
`;

const adminAccountPortfoliosQuery = gql`
  query AdminAccountPortfolios($accountId: Int!) {
    adminAccountPortfolios(accountId: $accountId) {
      dbId
      name
      year
    }
  }
`;

const moveToPortfolioMutation = gql`
  mutation moveToPortfolioMutation($id: Int!, $portfolioId: Int!) {
    updateInvestment(id: $id, portfolioId: $portfolioId) {
      success
      id
      error
    }
  }
`;

export const getDonors = (client: ApolloClient<object>) =>
  client.query<DonorsResponse>({ query: partnerQueueAccountsQuery, fetchPolicy: 'network-only' });

export const getPartnerQueue = (client: ApolloClient<object>, accountId: number) =>
  client.query<PartnerQueueResponse>({
    query: partnerQueueQuery,
    variables: { accountId },
    fetchPolicy: 'network-only',
  });

export const getAdminAccountPortfolios = (client: ApolloClient<object>, accountId: number) =>
  client.query<AdminAccountPortfoliosResponse>({
    query: adminAccountPortfoliosQuery,
    variables: { accountId },
    fetchPolicy: 'network-only',
  });

export const moveInvestmentToPortfolio = (
  client: ApolloClient<object>,
  id: number,
  portfolioId: number,
) =>
  client.mutate<MoveToPortfolioResponse>({
    mutation: moveToPortfolioMutation,
    variables: { id, portfolioId },
  });
